import { render, staticRenderFns } from "./student_lookup.vue?vue&type=template&id=7ba9a402&scoped=true&"
import script from "./student_lookup.vue?vue&type=script&lang=ts&"
export * from "./student_lookup.vue?vue&type=script&lang=ts&"
import style0 from "./student_lookup.vue?vue&type=style&index=0&id=7ba9a402&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba9a402",
  null
  
)

export default component.exports